import TESimpleEmail from './TESimpleEmail';

export default TESimpleEmail;
